/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useAccordionContext } from '@coursera/cds-core';

import ToggleButton from 'bundles/unified-description-page-common/components/accordions/ToggleButton';

export type MultiActionAccordionHeaderElement = React.ReactElement<Props, typeof MultiActionAccordionHeader>;

export type Props = {
  children?: React.ReactNode | React.ReactNode[];
  toggleButtonLabel: string;
  toggleButtonAriaLabel?: string;
  trackingName?: string;
  labelProps: Record<string, string>;
};

const styles = {
  header: (isExpanded: boolean) => css`
    display: flex;
    align-content: space-between;

    &:hover button span {
      display: flex;
    }

    button span {
      display: ${isExpanded ? 'flex' : ''};
    }
  `,
  title: css`
    flex: 1;
    padding: var(--cds-spacing-150) var(--cds-spacing-200) var(--cds-spacing-150) 0;
    overflow: hidden;
  `,
};

const MultiActionAccordionHeader = React.forwardRef(function MultiActionAccordionHeader(
  props: Props,
  ref: React.Ref<HTMLHeadingElement>
) {
  const { children, toggleButtonLabel, trackingName, toggleButtonAriaLabel } = props;
  const context = useAccordionContext();

  return (
    <div ref={ref} css={styles.header(Boolean(context?.expanded))}>
      <div css={styles.title}>{children}</div>
      <ToggleButton label={toggleButtonLabel} trackingName={trackingName} ariaLabel={toggleButtonAriaLabel} />
    </div>
  );
});

export default MultiActionAccordionHeader;
